<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-form inline class="mb-4">
          <label class="mr-2" for="dateInput">from</label>
          <b-form-input id="dateInput" class="mr-2" type="date" v-model="startDate" required> </b-form-input>
          <label class="mr-2" for="dateInput">to</label>
          <b-form-input id="dateInput" class="mr-2" type="date" v-model="endDate" required> </b-form-input>
          <b-form-select class="mr-2" v-model="userType" :options="userTypeOptions" @change="updateActions" />
          <b-form-select class="mr-2" v-model="col" :options="colOptions" @change="updateActions" />
          <b-form-select class="mr-2" v-if="showActionOptions" v-model="action" :options="actionOptions" />
          <b-button variant="primary" v-if="showActionOptions" v-on:click="reload">Apply</b-button>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div id="chart" style="width: 80%; height: 500px;"></div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import * as echarts from 'echarts'
const theme = { color: ['#00338D', '#005EB8', '#0091DA', '#483698', '#470A68', '#6D2077', '#00A3A1', '#009A44', '#43B02A', '#EAAA00'] }
echarts.registerTheme('kpmg', theme)

export default {
  created: function () {
    // we don't need to do anything on creating component because we don't know what data to load until the user select options
  },
  data () {
    return {
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      action: null,
      actionOptions: [],
      col: null,
      colOptions: [
        { value: null, text: "Select Column" },
        { value: 'action', text: 'actions' },
        { value: 'model', text: 'models' },
        { value: 'page', text: 'pages' },
        { value: 'user', text: 'users' }
      ],
      userType: 0,
      userTypeOptions: [
        { value: 0, text: 'internal users' },
        { value: 1, text: 'external users' }
      ],
      showActionOptions: false
    }
  },
  methods: {
    load: async function () {
      this.$logger.debug('loading timeseries-detailed started')
      this.loadingNewsRisk = true
      try {
        const apiName = 'cosmos'
        const path = `/stats/timeseries-detailed/${this.userType}/${this.col}/${this.action}/${this.startDate}/${this.endDate}`
        const graphData = await this.$Amplify.API.get(apiName, path)
        const optionTrend = {
          dataset: {
            source: graphData
          },
          xAxis: {
            type: 'time'
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'timeseries',
              type: 'line',
              smooth: true,
              encode: {
                y: 'count',
                x: 'date'
              }
            }
          ]
        }
        echarts.init(document.getElementById('chart'), 'kpmg').setOption(optionTrend)
      } catch (e) {
        this.$logger.warn('loading error' + e)
      }
    },
    reload: function () {
      echarts.dispose(document.getElementById('chart'))
      this.load()
    },
    updateActions: async function () {
      try {
        // it's good to set visibility flag to false so that forms don't who while we are updating data
        this.showActionOptions = false
        const apiName = 'cosmos'
        const path = `/stats/unique/${this.userType}/${this.col}/${this.startDate}/${this.endDate}`
        const dropdownRawData = await this.$Amplify.API.get(apiName, path)
        const actionArray = [{ "value": null, "text": "Select " + this.col }]
        _.each(dropdownRawData, x => actionArray.push({ "value": x, "text": x }))
        this.actionOptions.sort()
        this.actionOptions = actionArray
        // assign null to this.action so that by default the first option "select..." is visible
        this.action = null
        this.showActionOptions = true
      } catch (e) {
        this.$logger.warn('error updating actions:' + e)
      }
    }
  }
}
</script>

<style></style>
